export interface PdfAnnotation {
  page: number;
  left: number;
  top: number;
  width: number;
  height: number;
  color: string;
  border: string;
  type: AnnotationType;
  id: string;
}

export enum AnnotationType {
  Marker = 'Marker',
  Highlight = 'Highlight',
}

export const ANNOTATION_CLASS = 'gk-pdf-annotation';
export const NG2_PDFJS_VIEWER_IFRAME = 'ng2-pdfjs-viewer iframe';
export const PAGE_SELECTOR = 'page';
